import Insurances from "@components/Reason/Insurances";
import {useTranslation} from "ni18n";
import React from "react";

const Header: React.FC = () => {
  const i18n = useTranslation();

  return (
    <div className="bg-darkerBlue pt50 pt34-lg pt24-sm contrast-tbb">
      <Insurances
        headerText={i18n.t(
          "We accept most major insurance plans. No insurance? See our clear prices before you book.",
        )}
        isFullWidth
      />
      <div
        className="minh30 w100p bgpc"
        style={{backgroundImage: `url(/static/img/v5/patterns/splatter.webp)`}}
      />
    </div>
  );
};

export default Header;
